module.exports = __webpack_public_path__ + "img/logo_xiuye_hf@2x.8877588c.png";